import React from "react"

export default function AboutPage() {
  return <h1>About Page</h1>
}
